var _polygon, _path, _polygon2, _path2, _polygon3, _path3, _polygon4, _polygon5, _polygon6, _rect, _polygon7, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCilQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "48 48 176 48 176 16 16 16 16 176 48 176 48 48",
    className: "ci-primary"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, currentColor)",
    d: "M176,176V80H80v96h96Zm-64-64h32v32H112Z",
    className: "ci-primary"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "328 48 464 48 464 176 496 176 496 16 328 16 328 48",
    className: "ci-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, currentColor)",
    d: "M432,176V80H336v96h96Zm-64-64h32v32H368Z",
    className: "ci-primary"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "176 464 48 464 48 336 16 336 16 496 176 496 176 464",
    className: "ci-primary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--ci-primary-color, currentColor)",
    d: "M176,336H80v96h96V336Zm-32,64H112V368h32Z",
    className: "ci-primary"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "464 464 328 464 328 496 496 496 496 336 464 336 464 464",
    className: "ci-primary"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "272 304 400 304 400 368 432 368 432 272 272 272 272 304",
    className: "ci-primary"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "432 432 432 400 240 400 240 272 80 272 80 304 208 304 208 432 432 432",
    className: "ci-primary"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 96,
    x: 208,
    y: 80,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "var(--ci-primary-color, currentColor)",
    points: "80 240 304 240 304 80 272 80 272 208 80 208 80 240",
    className: "ci-primary"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    x: 336,
    y: 208,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 336,
    y: 336,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 272,
    y: 336,
    fill: "var(--ci-primary-color, currentColor)",
    className: "ci-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilQrCode);
export default __webpack_public_path__ + "static/media/cil-qr-code.5da5a67e6b81222676e0e03c1e7299ec.svg";
export { ForwardRef as ReactComponent };